import { schema } from 'normalizr';

export const subscription = new schema.Entity('subscriptions');
export const subscriptions = [subscription];

subscription.define({
  customer: require('shared/store/modules/subscribers/schemas').subscriber,
  utility: require('shared/store/modules/utilities/schemas').utility
});
